import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";
import React, { useState, useContext, useCallback, createContext } from 'react';
import { PopUpStyled, PopUpContainer, PopUpContent } from './styles';
var PopUpContext = createContext();
var SESSION_STORAGE_KEY = '__POPUP_STATE__';
var storage = {
  get: function get(key, defaultValue) {
    try {
      var value = window.sessionStorage.getItem(key);

      if (value === null) {
        return defaultValue;
      }

      return JSON.parse(value);
    } catch (e) {
      return defaultValue;
    }
  },
  set: function set(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
};
export function PopUpActions(props) {
  var onClick = useContext(PopUpContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "btn-box btn-box--center mt--10 mb--10"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: onClick
  }, "ANO"), /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return window.history.back();
    }
  }, "NE"));
}
export function PopUp(props) {
  var shouldRender = process.env.ENV_RAW || !props.edit;

  var _useState = useState(function () {
    return shouldRender ? storage.get(SESSION_STORAGE_KEY, true) : false;
  }),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var onClick = useCallback(function () {
    storage.set(SESSION_STORAGE_KEY, false);
    setIsOpen(false);
  }, [setIsOpen]);

  if (shouldRender && isOpen) {
    return /*#__PURE__*/React.createElement(PopUpContext.Provider, {
      value: onClick
    }, /*#__PURE__*/React.createElement(PopUpStyled, {
      id: props.name,
      className: props.className
    }, /*#__PURE__*/React.createElement(PopUpContainer, null, /*#__PURE__*/React.createElement(PopUpContent, null, props.children))));
  }

  return /*#__PURE__*/React.createElement("div", null);
}